import { createApi } from '@reduxjs/toolkit/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const spApi = createApi({
  reducerPath: 'spApi',
  baseQuery: rtkBaseQuery('/sps'),
  endpoints: (builder) => ({
    spItemsList: builder.mutation({
      query: ({ tableName, ...body }) => ({
        url: `/SP/SpItemsList/${tableName}`,
        method: 'POST',
        body,
      }),
    }),

    getAllTranslations: builder.query({
      query: (params) => ({
        url: '/SP/GetAllTranslations',
        params,
      }),
    }),

    createNewTableSPS: builder.mutation({
      query: ({ tableName, ...body }) => ({
        url: `/SP/CreateNewTableSPS/${tableName}`,
        method: 'POST',
        body,
      }),
    }),

    addUpdate: builder.mutation({
      query: ({ tableName, ...body }) => ({
        url: `/SP/AddUpdate/${tableName}`,
        method: 'POST',
        body,
      }),
    }),

    createLang: builder.mutation({
      query: (body) => ({
        url: 'Lang/Create',
        method: 'POST',
        body,
      }),
    }),

    updateLang: builder.mutation({
      query: (body) => ({
        url: 'Lang/Update',
        method: 'PUT',
        body,
      }),
    }),

    deleteLang: builder.mutation({
      query: ({ id }) => ({
        url: `Lang/Delete?id=${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useSpItemsListMutation,
  useGetAllTranslationsQuery,
  useCreateNewTableSPSMutation,
  useAddUpdateMutation,
  useCreateLangMutation,
  useUpdateLangMutation,
  useDeleteLangMutation,
} = spApi;
